import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_DOAMIN; // backend 서버 도메인

export default axios.create({
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});
